// app/ has no slice, so no config/ to hold constants — colocate them next to the
// component per spec §4.3 (docs/superpowers/specs/2026-07-30-separate-ui-logic-design.md).
const FRONT_END_ERRORS = {
  DOMAIN_BLOCKED: 'DOMAIN_BLOCKED',
  SOCKET_CONNECTION_ERROR: 'SOCKET_CONNECTION_ERROR',
  ADD_SIGNATURE_TIME_TRACKING: 'ADD_SIGNATURE_TIME_TRACKING',
};

const TRACKING_SOCKET_ERRORS = ['transport error'];

export { FRONT_END_ERRORS, TRACKING_SOCKET_ERRORS };
